export const viewsKeys = {
  all: ['views'] as const,
  indexViews: (indexId?: number) => [...viewsKeys.all, 'indexViews', indexId] as const,
  singleView: (viewId?: number) => [...viewsKeys.all, 'singleView', viewId] as const,
  singleViewForLocale: (viewId?: number, locale?: string) => [...viewsKeys.singleView(viewId), locale] as const,
  writePermission: (indexId?: number) => [viewsKeys.all, 'write-permissinons', indexId] as const,
  createPermission: () => [viewsKeys.all, 'create-permissions'] as const
};

